// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brands-grid[data-v-3f44a8e1]{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));grid-gap:8px}@media only screen and (min-width:992px){.brands-grid[data-v-3f44a8e1]{grid-gap:12px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
